import instaclustrComponent from "./Components";
import layoutResizing from "../utils/layoutResizing";


export class Component extends instaclustrComponent {
    constructor(name, node) {
        super(name, node);
    }
    init() {
        console.log(this.name);

        // Breakpoint references
        let sm = 576,
            md = 768,
            lg = 992,
            xl = 1200;

        // Viewport width helper function
        function viewport() {
            let e = window,
                a = 'inner';
            if (!('innerWidth' in window)) {
                a = 'client';
                e = document.documentElement || document.body;
            }
            return { width: e[ a + 'Width' ], height : e[ a + 'Height'] };
        }

        let vpWidth       = viewport().width;
        let headOffset= 230;

        let $stickyNav    = $('.component.component-sticky-nav-2024 nav');
        let $navContainer = $stickyNav.parent();
        let $navList      = $stickyNav.find('ul');
        let $navHeight    = $navList.height();
        let $navWidth     = $navContainer.width();
        let $navOffset    = $stickyNav.offset().top; // nav's distance from top of window

        let $contents     = $('.sticky-nav-contents');
        let $bottom       = $('#bottomAnchor');
        let $bottomOffset = $bottom.offset().top;

        function icStickyNav() {
            let $scrollTop = $(window).scrollTop(); // current distance from top of window
            if (vpWidth >= md) {
                if ($scrollTop + $navHeight > $bottomOffset - headOffset - 50) {
                    $stickyNav.css({
                        'top'   : (($scrollTop + $navHeight - $bottomOffset) * -1) - 50
                    });
                }
                else if ($scrollTop >= $navOffset - headOffset) {
                    $stickyNav.css({
                        'position' : 'fixed',
                        'top'      : '230px',
                        'width'    : $navWidth
                    });
                }
                else {
                    $stickyNav.css({
                        'position' : 'relative',
                        'top'      : '0',
                        'width'    : $navWidth
                    });
                }
            }
        }

        icStickyNav();

        // Set smooth scroll behavior
        let $navItems = $navList.find('li');
        $navItems.each(function() {
            $(this).click(function() {
                let id = $(this).find('a').attr('href');
                let section = $(id);
                $('html, body').stop().animate({
                    scrollTop: section.offset().top - headOffset
                });
            })
        });

        // Set 'scrollspy' behavior (highlight sections as they are scrolled into view)
        function scrollSpy() {
            let $scrollTop = $(window).scrollTop(); // current distance from top of window
            $navItems.each(function() {
                let $secLink   = $(this).find('a');
                let $secId     = $secLink.attr('href');
                let $section   = $($secId);
                let $secHeight = $section.height();
                let $secOffset = $section.offset().top;
                if ($secOffset - $scrollTop < headOffset + 1 && $secOffset - $scrollTop > headOffset - $secHeight) {
                    if (!$secLink.hasClass('active')) {
                        $secLink.addClass('active');
                    }
                } else {
                    if ($secLink.hasClass('active')) {
                        $secLink.removeClass('active');
                    }
                }
            });
        }

        scrollSpy();

        // Invoke nav check and scrollspy on scroll
        $(window).scroll(function() {
            icStickyNav();
            scrollSpy();
        });

        // Refresh page on resize to avoid layout issues
        layoutResizing();

        // Mobile select behavior
        let $selectMenu = $('.component-sticky-nav-2024 select.tabs-select');

        $selectMenu.each(function(i) {
            $(this).on('change', (event) => {
                const selectedId = event.target.value;
                console.log(selectedId);
                let section = $('#' + selectedId);
                console.log(section);
                $('html, body').stop().animate({
                    scrollTop: section.offset().top - 120
                });
            });
        });

    }
}
